import script from "./SalesReportNewGraphic.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesReportNewGraphic.vue?vue&type=script&setup=true&lang=ts"

import "./SalesReportNewGraphic.vue?vue&type=style&index=0&id=4f97f7dc&lang=scss"

const __exports__ = script;

export default __exports__